export default __webpack_public_path__ + "static/media/user-rounded.c985962c.svg";